import { CATEGORY_META } from '../../../shared/constants';

export function getCategoryDisplay(t, categoryCode) {
  const fallback = CATEGORY_META[categoryCode];
  const translationKey = `emissionFactor.categoryDisplay.${categoryCode}`;

  return {
    short: t(`${translationKey}.short`, { defaultValue: fallback?.short || categoryCode }),
    label: t(`${translationKey}.label`, { defaultValue: fallback?.label || '' }),
  };
}
